'use strict';

/*global isEmpty*/
/*global services*/

function initialize($wrapper, dashboard) {
  $wrapper.find('.search-select').each(function () {
    var $select = $(this);

    $select.selectpicker({
      style: 'btn-default' + ($select.attr('readonly') ? ' disabled' : ''),
      liveSearch: true
    });
  });

  $wrapper.find('.js-datepicker').each(function () {
    var $input = $(this);
    $input.datepicker({ language: services.get('configurations').param('locale'), autoclose: true, todayBtn: 'linked', todayHighlight: true, format: 'dd.mm.yyyy' });

    $input.inputmask({ alias: 'dd.mm.yyyy' });
  });

  $wrapper.find('.js-clockpicker').each(function () {
    var $input = $(this);

    $input.clockpicker({ autoclose: true, default: 'now' });
    $input.inputmask({ alias: 'hh:mm' });
  });

  $wrapper.find('.loadOtherItems').k2_loadOtherItems();
  $wrapper.find('.lookup').k2_lookup({ searchEmptyString: true });
  $wrapper.find('.labels').k2_labels();
  $wrapper.find('.help-box').k2_helpBox();
  $wrapper.find('form').k2_filterClear();
  $wrapper.find('.file-wrapper').k2_fileUpload();
  $wrapper.find('.form-commands-menu').k2_form_commands_menu();

  var filterLoadSummaryOptions = {};
  filterLoadSummaryOptions.onLoadCallback = function (data) {
    initialize(data.container);
  };

  $wrapper.find('.widget-calendar').widget_calendar();
  $wrapper.find('.widget-comments').widget_comments();
  $wrapper.find('.widget-job_queue').widget_jobQueue();
  $wrapper.find('.widget-job_queue_status_chart').widget_jobQueueStatusChart();
  $wrapper.find('.widget-capacity_planning').widget_capacityPlanning();

  //$wrapper.find('.widget-timesheets_chart').widget_timesheetsChart();

  $wrapper.find('.load-detail').detailLoader();
  $wrapper.find('.js-date-interval-select').dateIntervalSelect({ preFillValue: false });

  $wrapper.find('[data-widget-filter-submit]').on('click', function () {
    if (dashboard) {
      dashboard.$submitActor = $(this);
    }
  });

  $wrapper.find('.form-resources-wrapper').k2_formCollection({
    allowRemove: function ($item) {
      return isEmpty($item.find('.primary-key').val());
    },

    btnAddContent: '<span class="glyphicon glyphicon-plus" title="' + services.get('translator').trans('project_stage_planned_operation_resource.add') + '"></span>',
    btnRemoveContent: '<span class="glyphicon glyphicon-remove" title="' + services.get('translator').trans('project_stage_planned_operation_resource.remove') + '"></span>',
    btnClass: 'btn btn-custom'
  });

  $wrapper.find('.form-attachments-wrapper').k2_formCollection({
    btnAddContent: '<span class="glyphicon glyphicon-plus" title="' + services.get('translator').trans('add') + '"></span>',
    btnRemoveContent: '<span class="glyphicon glyphicon-remove" title="' + services.get('translator').trans('remove') + '"></span>',
    btnClass: 'btn btn-custom'
  });

  $wrapper.find('[data-toggle="tooltip"]').tooltip();
  $wrapper.find('.table-collapsible').k2_tableCollapsible();
  $wrapper.find('.table-hover').k2_tableFixedHover();
  $wrapper.find('.table-fixed-columns').tableFixedColumns();
  $wrapper.find('.tree-collapsible').k2_treeCollapsible();
  $wrapper.find('.panel-collapsible').k2_panelCollapsible();
  $wrapper.find('.form-control--jeditable').k2_jeditable();
  $wrapper.find('.char-counter').k2_charCounter();
}

$(document).ready(function () {
  initialize($('body'));
  $('#sidebar-toggle').k2_sidebarToggle();

  $('body').k2_onscreenInput({
    timeout: 800,
    afterChange: function (input) {
      var el = input;
      while (el.length > 0 && el.prop('tagName') !== 'FORM') {
        el = el.parent();
      }

      if (el.prop('tagName') === 'FORM') {
        el.submit();
      }
    }
  });

  $('body').on('click', '.toggle-detail-all', function () {
    var state = state;
    if ($(this).find('.glyphicon').hasClass('glyphicon-triangle-right')) {
      state = 'right';
      $(this).find('.glyphicon').removeClass('glyphicon-triangle-right').addClass('glyphicon-triangle-bottom');
    } else {
      state = 'bottom';
      $(this).find('.glyphicon').removeClass('glyphicon-triangle-bottom').addClass('glyphicon-triangle-right');
    }

    $(this).closest('table').find('.load-detail .glyphicon-triangle-' + state).closest('.load-detail').click();

    return false;
  });
});
